export default class TpPaymentRequestStatusChangeItem {
  constructor(item) {
    this.initialize(item);
  }

  initialize(item) {
    this.TpEvaluatorTpJobPaymentId = item.tpEvaluatorTpJobPaymentId;
    this.Action = '';
    this.Comment = '';
  }
}
